import { useState } from 'react';
import { JobListing } from '../types/jobs';
import { useNavigate } from 'react-router-dom';
import { BtnPrimary } from './common/Buttons';

const IndustrySelect = ({ jobListings }: { jobListings: JobListing[] }) => {
  const [category, setCategory] = useState('');
  const [showInput, setShowInput] = useState(false);
  const navigate = useNavigate();

  const uniqueCategories = Array.from(
    new Set(
      jobListings?.filter((job) => job.category).map((job) => job.category)
    )
  );

  return (
    <div className="bg-white w-full">
      <div className="max-h-48 overflow-y-auto pb-2">
        {uniqueCategories.map((category) => (
          <div
            key={category}
            onClick={() => navigate(`/job-listings/create/${category}`)}
            className="p-2 cursor-pointer rounded hover:bg-greyTwenty transition-colors duration-200 capitalize border-b border-greyThirty last:border-b-0"
          >
            {category?.replace('-', ' ')}
          </div>
        ))}
      </div>
      <div className="flex flex-col gap-2">
        <input
          type="text"
          value={category}
          onChange={(e) => setCategory(e.target.value)}
          placeholder="Enter Category"
          className={`${!showInput ? 'hidden' : ''} border outline-none p-2 placeholder:text-sm`}
        />
        <BtnPrimary
          onClick={() => {
            if (category) {
              navigate(`/job-listings/create/${category}`);
            } else {
              setShowInput(true);
            }
          }}
          className="w-full border py-2 rounded-lg mt-4"
        >
          {category ? 'Update' : 'Create New'}
        </BtnPrimary>
      </div>
    </div>
  );
};

export default IndustrySelect;
